export default __webpack_public_path__ + "static/media/Perkins Eastman.9a3ee2f8.jpg";